import type { UserDto } from '@/castapi';
import { getEducationalApi } from '@/castapi/helpers';
import TableParamsState, { type ITableParamsState } from '@/store/modules/common/tableParamsState';

const tableParams = new TableParamsState();

type IEduState = ITableParamsState & {
  students: UserDto[];
  studentsLoading: boolean;
  studentsLoadError: string;
};

const initialState = (): IEduState => ({
  ...tableParams.state(),
  students: [],
  studentsLoading: false,
  studentsLoadError: null,
});

export default {
  namespaced: true,

  state: initialState(),

  mutations: {
    ...tableParams.mutations,
    RESET_STATE(state: IEduState): void {
      // unused
      Object.assign(state, initialState());
    },
    STUDENTS_LOADED(state: IEduState, students: UserDto[]): void {
      state.studentsLoading = false;
      state.students = students;
    },
    STUDENTS_LOADING(state: IEduState): void {
      state.studentsLoading = true;
      state.studentsLoadError = null;
    },
    STUDENTS_LOAD_ERROR(state: IEduState, error: string): void {
      state.studentsLoading = false;
      state.studentsLoadError = error;
    },
  },

  actions: {
    ...tableParams.actions,
    async loadStudents({ commit, rootGetters }) {
      commit('STUDENTS_LOADING');
      try {
        const accessToken = rootGetters['login/accessToken'];
        const response = await getEducationalApi(accessToken).educationalControllerGetSchoolStudents();
        commit('STUDENTS_LOADED', response.data);
      } catch (error) {
        commit('STUDENTS_LOAD_ERROR', error);
      }
    },
  },

  getters: {
    ...tableParams.getters,
    students: (state: IEduState): UserDto[] =>
      state.students.map(student => ({
        ...student,
        userName: `${student.firstName} ${student.lastName}`,
      })),
    studentsLoading: (state: IEduState): boolean => state.studentsLoading,
    studentsLoadError: (state: IEduState): string => state.studentsLoadError,
  },
};
